import { CCol, CRow, CButton } from "@coreui/react";
import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import CommonList from "../crud/CommonList";
import { apiCall } from "src/_apiConfig/apiCall";

const ReportTenderCircle = () => {
  const [reportdata, setreportdata] = useState();
  const [tenderinfo, settenderinfo] = useState();
  const [loading, setloading] = useState(false);
  let history = useHistory();
  let { id } = useParams();
  const decrypted = window.atob(id);
  useEffect(() => {
    getTenderReport();
    getTenderInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const fields = [
    {
      key: "name",
      label: "Circle Name",
    },
    {
      key: "circle_lot_count",
      label: "Circle Lot Count",
    },
    {
      key: "bidderAndCCFSigned",
      label: "Bidder And CCF Signed",
    },
    {
      key: "onlyBidderSigned",
      label: "Only Bidder Signed",
    },
    {
      key: "bidderNoAction",
      label: "Bidder NoAction",
    },
    {
      key: "day7Extentions",
      label: "Day7 Extensions",
    },
    {
      key: "secondExtentions",
      label: "Second Extensions",
    },
    {
      key: "multipleExtention",
      label: "Multiple Extensions",
    },
    {
      key: "noExtentions",
      label: "No Extensions",
    },
  ];

  const getTenderInfo = async () => {
    console.log("decrypted: " + decrypted);
    console.log("id: " + id);
    setloading(true);
    const header = new Headers();
    const response = await apiCall(
      `Tender/GetTenderAddtinoalInfo?tenderid=${decrypted}`,
      "GET",
      header,
      null
    );

    const jsonobj = await response.json();

    if (response.status === 200) {
      settenderinfo(jsonobj);
      //settenderNo(jsonobj.tenderNo)

      setloading(false);
    }
  };

  const getTenderReport = async () => {
    console.log("decrypted: " + decrypted);
    console.log("id: " + id);
    setloading(true);

    const header = new Headers();
    const response = await apiCall(
      `Tender/TenderReport?tenderid=${decrypted}`,
      "GET",
      header,
      null
    );

    const jsonobj = await response.json();
    if (response.status === 200) {
      setreportdata(jsonobj);
      setloading(false);
      console.log(jsonobj);
    }
  };

  const dataShow = (lable, value) => {
    return (
      <CRow className="mt-3 ml-2">
        <CCol xl={3} lg={6} md={6} sm={6}>
          <strong>{lable}</strong>
        </CCol>
        <CCol xl={9} lg={6} md={6} sm={6}>
          <strong>:</strong> &nbsp;
          {tenderinfo !== undefined ? value : ""}
        </CCol>
      </CRow>
    );
  };
  return (
    <>
      <CRow className={"ml-2"}>
        <CCol xl={12}>
          <h1>Tender Circle Wise Report</h1>
          <hr></hr>
        </CCol>
      </CRow>

      {dataShow("Tender No", tenderinfo?.tenderNo)}
      {dataShow("Sanction Date", tenderinfo?.sanctionDate)}
      {dataShow(
        "Bidder Agreement Signed Last Date",
        tenderinfo?.bidderAgreementSignedLastDate
      )}
      {dataShow(
        "CFO Agreement Signed Last Date",
        tenderinfo?.cfoAgreementSignedLastDate
      )}
      {dataShow(
        "Day7 Bidder Extention Date",
        tenderinfo?.day7BidderExtentionDate
      )}
      {dataShow("Day7 CFO Extention Date", tenderinfo?.day7CFOExtentionDate)}
      {dataShow(
        "Second Extention Bidder Last Date",
        tenderinfo?.secondExtentionBidderLastDate
      )}
      {dataShow(
        "Second Extention CFO Last Date",
        tenderinfo?.secondExtentionCFOLastDate
      )}

      {/* <br />
      <br />
      <CRow className="mt-2 ml-2">
        <CCol xl={3}>
          <strong>Tender No:</strong>
        </CCol>
        <CCol xl={9}>
          {tenderinfo !== undefined ? tenderinfo.tenderNo : ""}
        </CCol>
      </CRow>
      <CRow className="mt-3 ml-2">
        <CCol xl={3}>
          <strong>Sanction Date:</strong>
        </CCol>
        <CCol xl={9}>
          {tenderinfo !== undefined ? tenderinfo.sanctionDate : ""}
        </CCol>
      </CRow>
      <CRow className="mt-3 ml-2">
        <CCol xl={3}>
          <strong>Bidder Agreement Signed Last Date:</strong>
        </CCol>
        <CCol xl={9}>
          {tenderinfo !== undefined
            ? tenderinfo.bidderAgreementSignedLastDate
            : ""}
        </CCol>
      </CRow>
      <CRow className="mt-3">
        <CCol xl={3}>
          <strong>CFO Agreement Signed Last Date:</strong>
        </CCol>
        <CCol xl={9}>
          {tenderinfo !== undefined
            ? tenderinfo.cfoAgreementSignedLastDate
            : ""}
        </CCol>
      </CRow>
      <CRow className="mt-3">
        <CCol xl={3}>
          <strong>Day7 Bidder Extention Date:</strong>
        </CCol>
        <CCol xl={9}>
          {tenderinfo !== undefined ? tenderinfo.day7BidderExtentionDate : ""}
        </CCol>
      </CRow>
      <CRow className="mt-3">
        <CCol xl={3}>
          <strong>Day7 CFO Extention Date:</strong>
        </CCol>
        <CCol xl={9}>
          {tenderinfo !== undefined ? tenderinfo.day7CFOExtentionDate : ""}
        </CCol>
      </CRow>
      <CRow className="mt-3">
        <CCol xl={3}>
          <strong>Second Extention Bidder Last Date:</strong>
        </CCol>
        <CCol xl={9}>
          {tenderinfo !== undefined
            ? tenderinfo.secondExtentionBidderLastDate
            : ""}
        </CCol>
      </CRow>
      <CRow className="mt-3">
        <CCol xl={3}>
          <strong>Second Extention CFO Last Date:</strong>
        </CCol>
        <CCol xl={9}>
          {tenderinfo !== undefined
            ? tenderinfo.secondExtentionCFOLastDate
            : ""}
        </CCol>
      </CRow> */}
      <CRow>
        <CCol xl={12}>
          <CommonList
            items={reportdata}
            fields={fields}
            listName=""
            loading={loading}
            disabledprev="true"
            disablednext="true"
          />
        </CCol>
      </CRow>
      <CRow>
        <CCol xl={12}>
          <CButton
            color="dark"
            onClick={() => history.goBack()}
            className={"ml-3 mb-2"}
          >
            Go Back
          </CButton>
        </CCol>
      </CRow>
    </>
  );
};

export default ReportTenderCircle;
